{
  "dismiss": "تجاهل"
}
